// extracted by mini-css-extract-plugin
module.exports = {"inputRoot":"DateRangeInput_inputRoot___kivb","withMobileMargins":"DateRangeInput_withMobileMargins__3Fl1G","arrowIcon":"DateRangeInput_arrowIcon__DOh8I"};